module.exports = __webpack_public_path__ + "static/media/Roboto-Light.ed4b08d2.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-Light.woff2
// module id = 528
// module chunks = 0